module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExtIt.94e146d.ttf";